export const SET_SEARCHPRICE = 'SET_SEARCHPRICE';
export const SET_SEARCHPRICE_SUCCESS = 'SET_SEARCHPRICE_SUCCESS';

export const SET_SEARCHINFOCALENDAR = 'SET_SEARCHINFOCALENDAR';
export const SET_SEARCHINFOCALENDAR_SUCCESS = 'SET_SEARCHINFOCALENDAR_SUCCESS';

export const SET_SEARCHINFOCALENDAR_BAR = 'SET_SEARCHINFOCALENDAR_BAR';
export const SET_SEARCHINFOCALENDAR_BAR_SUCCESS = 'SET_SEARCHINFOCALENDAR_BAR_SUCCESS';

export const SET_MINIRULEINFO = 'SET_MINIRULEINFO';
export const SET_MINIRULEINFO_SUCCESS = 'SET_MINIRULEINFO_SUCCESS';

export const SET_FLIGHTFIXEDRULE = 'SET_FLIGHTFIXEDRULE';
export const SET_FLIGHTFIXEDRULE_SUCCESS = 'SET_FLIGHTFIXEDRULE_SUCCESS';

export const SET_URLPARAMS = 'SET_URLPARAMS';
export const SET_FILTERDATA = 'SET_FILTERDATA';
export const SET_SHOWDATA = 'SET_SHOWDATA';
export const SET_SORTTYPE = 'SET_SORTTYPE';

export const SET_NOTICEINFO = 'SET_NOTICEINFO';
export const SET_SALEINFO = 'SET_SALEINFO';

export const SET_FARERULEINFO = 'SET_FARERULEINFO';
export const SET_FARERULEINFO_SUCCESS = 'SET_FARERULEINFO_SUCCESS';